import {useMemo} from "react";
import AccordionItemContext, {AccordionItemContextValue} from "react-bootstrap/AccordionItemContext";

import {AccordionItemProps} from "@/components/accordion/subComponents/AccordionItem/AccordionItem.types.ts";

const AccordionItem = ({children, eventKey, className}: AccordionItemProps) => {
  const contextValue = useMemo<AccordionItemContextValue>(
    () => ({
      eventKey,
    }),
    [eventKey]
  );

  return (
    <AccordionItemContext.Provider value={contextValue}>
      <div className={className}>{children}</div>
    </AccordionItemContext.Provider>
  );
};

AccordionItem.displayName = "AccordionItem";
export {AccordionItem};
